export const MAIN_ALLIANCE_TEST_IDS = {
  // ─── Alliance Benefits Section ───
  sectionContainer: 'main-alliance-section-container',
  sectionIcon: 'main-alliance-section-icon',
  sectionHeadline: 'main-alliance-section-headline',

  // ─── Alliance Benefit Cards ───
  cardList: 'main-alliance-card-list',
  card: (index: number) => `main-alliance-card-${index}`,
  cardImage: (index: number) => `main-alliance-card-image-${index}`,
  cardTitle: (index: number) => `main-alliance-card-title-${index}`,
  cardDescription: (index: number) => `main-alliance-card-description-${index}`,
  cardLink: (index: number) => `main-alliance-card-link-${index}`,
} as const;
